// extracted by mini-css-extract-plugin
module.exports = {"container":"menus-mobile-container","raggedBorder":"menus-mobile-raggedBorder","bottom":"menus-mobile-bottom"};